export default "__VITE_ASSET__DrNIPNGs__"